<div class="progressWrapper progressWrapperStar d-flex flex-nowrap align-items-center w-100">
  <div class="progress w-100 my-auto" [style.height]="height">
    <div class="progress-bar{{type ? ' bg-' + type : ''}}{{animated ? ' progress-bar-animated' : ''}}{{striped ?
      ' progress-bar-striped' : ''}}" role="progressbar" [style.width.%]="getPercentValue()"
      [attr.aria-valuenow]="getValue()" aria-valuemin="0" [attr.aria-valuemax]="max" [attr.aria-valuetext]="getValue() + ' of ' + max + ' stars earned'">
      @if (showValue) {
        <span i18n="@@ngb.progressbar.value">{{getPercentValue()}}</span>
      }
      <ng-content></ng-content>
    </div>
  </div>
  <div class="progressStarWrapper">
    <img class="progressStar" alt="{{altText}}" src="assets/img/{{starImage}}">
  </div>
</div>
